module.exports = __webpack_public_path__ + "static/img/bcg_e.ee03c91c.png";